<template>
  <div>
    <div class="control is-grouped">
      <p class="control">
        <a
          v-if="canCreate(permissionKey)"
          href="#/users/new"
          class="button is-success"
        >
          <span class="icon">
            <i class="fa fa-plus-circle"></i>
          </span>
          <span>Создать пользователя</span>
        </a>
      </p>
    </div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="paging-top">
            <Paging
              :refresh="loadData"
              :per-page="perPage"
              :data.sync="usersPage"
              :pagingClass="'top'"
            />
          </div>
          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow usersTable">
              <thead>
              <tr>
                <th>Имя</th>
                <th>Роль</th>
                <th>Шлюз по-умолчанию</th>
                <th>Биллинг</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(user, index) in usersPage.content">
                <td class="userNameCell">
                  <a
                    :href="'#/users/'+user.id"
                    v-if="user.userId && (user.role!=='СуперАдминистратор' || loggedRole === '1' || loggedRole === 1)"
                  >{{ user.name }}</a>
                  <span v-else>{{ user.name }}</span>
                </td>
                <td class="">
                  <span>{{ user.role }}</span>
                </td>
                <td class="">
                  <span>{{ user.defaultGateway }}</span>
                </td>
                <td class="billingEnable">
                  <span :class="!!user.billingEnable ? 'enable': ''">{{ getBillingLabel(user.billingEnable) }}</span>
                </td>

              </tr>
              </tbody>
            </table>
          </div>
          <div class="paging-bottom">
            <Paging
              :refresh="loadData"
              :per-page="perPage"
              :data.sync="usersPage"
              :pagingClass="'bottom'"
            />
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import VisCommon from '../components/VisCommon'
import Paging from '../components/Paging'
import {mapGetters} from 'vuex'

const USERS_API = '/api/userProfileClient'

export default {
  name: 'Users',
  extends: VisCommon,
  components: {
    Paging
  },
  computed: {
    ...mapGetters([
      'loggedUser',
      'loggedId',
      'loggedRole',
      'clientId',
      'authenticationToken'
    ])
  },
  data() {
    return {
      usersPage: {content: []},
      perPage: 16,
      searchName: '',
      showModal: null,

      permissionKey: 'user'
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData(page) {
      let that = this
      page = page ? (page - 1) : 0
      let url = USERS_API + '/filter' + '?page=' + page + '&pageSize=' + this.perPage
      this.$http.get(url, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          that.usersPage = response.data
        })
        .catch((error) => {
          console.log(error)
          that.openNotificationWithType('danger', 'Ошибка загрузки списка пользователей. ')
        })
    },
    getBillingLabel(billingEnable) {
      if (billingEnable === false) {
        return 'выключен'
      } else if (billingEnable === true) {
        return 'включён'
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Users.vue?d832fb7e